<script>
  import { config } from '../store.js';
  import FallbackImage from './fallback-image.svelte';

  /** @type {{item?: any}} */
  let { item = {}, index = 0 } = $props();

  // Wide cards:
  // - 0
  // - 6
  // - 10
  // - 16
  let wideCard = $derived(
    $config.mosaicResults ? index % 10 === 0 || (index - 6) % 10 === 0 : false
  );

  let imageUrl = $derived($config.origin + item.imageUrl);

  // visible tag only on the pinned/featured result
  // label from CMS dictionary
  let primaryTag = $derived(
    item.id == $config.boostId ? $config.strings.LABEL_PINNED : ''
  );

  let publishedDate = $derived.by(() => {
    if (!item.publishedDate) {
      return null;
    }
    const date = new Date(item.publishedDate);
    // console.debug(date);

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return new Intl.DateTimeFormat(undefined, options).format(date);
  });
</script>

<div
  class="grid-item"
  data-search-module-result-position={index}
  data-item-colspan={wideCard ? '2' : '1'}
>
  <!-- {@html renderTemplate({ item })} -->

  <div
    class="simple-card time-over-image square-image {wideCard ? 'show-excerpt' : ''}"
  >
    <a href={$config.origin + item.link} title={item.title}>
      <div class="card-image">
        {#if item.imageUrl}
          <picture>
            <img src={imageUrl} alt={item.imageAlt} />
          </picture>
        {:else}
          <FallbackImage />
        {/if}
      </div>

      <div class="card-content">
        <div class="card-meta">
          {#if item.readTime || publishedDate}
            <span class="time-meta">
              {#if item.readTime}
                <span class="read-time">
                  <svg
                    class="icon feather feather-clock"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" /><polyline
                      points="12 6 12 12 16 14"
                    />
                  </svg>
                  {item.readTime}
                </span>
              {/if}
              {#if publishedDate}
                | <time>{publishedDate}</time>
              {/if}
            </span>
          {/if}

          {#if wideCard && primaryTag}
            <span class="badge badge-filled">{primaryTag}</span>
          {/if}
        </div>

        <p class="card-heading">{item.title}</p>

        <p class="card-excerpt">
          {item.description}
        </p>
      </div>
    </a>
  </div>
</div>
